// extracted by mini-css-extract-plugin
module.exports = {"trustBar":"TrustBadges_trustBar__KuLMs","full":"TrustBadges_full__6yVVY","badge":"TrustBadges_badge__qAwF3","badgeValue":"TrustBadges_badgeValue__VPMxk","badgeLabel":"TrustBadges_badgeLabel__ieYAd"};
module.exports.__checksum = "a37a7eba0173"
